const binding = { modules: {}, dataActions: {} };

    (binding.modules['celli-script-injector'] = {
        c: () => require('partner/modules/celli-script-injector/celli-script-injector.tsx'),
        $type: 'scriptModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'celli-script-injector',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/celli-script-injector'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|celli-script-injector|celli-script-injector'] = {
                c: () => require('partner/modules/celli-script-injector/celli-script-injector.view.tsx'),
                cn: '__local__-__local__-celli-script-injector'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };